exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d-LbT {\n    font-size: 16px;\n    color: #767676;\n    margin-bottom: 30px;\n}\n._3s03m {\n    display: inline-block;\n    padding-left: 10px;\n    vertical-align: middle;\n}\n.pBE2q {\n    color: #5EBE00 !important;\n    text-decoration: none !important;\n}\n._1HAvG {\n    color: #E83A30 !important;\n    text-decoration: none !important;\n}\n.T8zop{\n    color: red\n}\n.Orh_A {\n    margin-left: 8px;\n    padding-right: 6px\n}\n.xLVQw {\n    color: #5EBE00 !important;\n    text-decoration: none !important;\n    display: inline-block;\n}\n._15bSn {\n    text-decoration: line-through;\n}\n@media screen and (max-width: 767px) {\n    ._3s03m {\n        display: block;\n        padding-left: 0px;\n    }\n    ._3kM5z {\n        width: 100%;\n    }\n}\n.ycHeF {\n    width: 100%;\n    max-width: 24px;\n    vertical-align: middle;\n    margin-right: 6px;\n}", ""]);

// exports
exports.locals = {
	"infoBox": "d-LbT",
	"displayInlineBtn": "_3s03m",
	"veriyText": "pBE2q",
	"removeText": "_1HAvG",
	"errorMessage": "T8zop",
	"removeImg": "Orh_A",
	"linkTextColor": "xLVQw",
	"lineThrough": "_15bSn",
	"btnWidthMobile": "_3kM5z",
	"iconsWidth": "ycHeF"
};